(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-reposts"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRepostSlider(root) {
    if (root.dataset.arInit) return;
    root.dataset.arInit = '1';
    var track = root.querySelector('[data-ar-track]');
    if (!track) return;
    var slides = [].slice.call(track.children);
    if (slides.length < 2) return;
    // Two cloned sets give the wrap-around loop room in both directions
    for (var c = 0; c < 2; c++) {
      slides.forEach(function (s) {
        var k = s.cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.removeAttribute('data-shopify-editor-block');
        track.appendChild(k);
      });
    }
    var setW = 0;
    function measure() { setW = track.scrollWidth / 3; }
    function centre() {
      if (setW && (track.scrollLeft < setW * 0.5 || track.scrollLeft > setW * 1.5)) track.scrollLeft = setW;
    }
    measure(); centre();
    // browsers can reset scroll after load — re-centre once everything settles
    window.addEventListener('load', function () { measure(); centre(); });
    window.addEventListener('resize', measure);
    track.addEventListener('scroll', function () {
      if (!setW) return;
      if (track.scrollLeft < setW * 0.5) track.scrollLeft += setW;
      else if (track.scrollLeft > setW * 1.5) track.scrollLeft -= setW;
    });
    // Mouse drag with free-scroll momentum (touch uses native scrolling)
    var down = false, startX = 0, startScroll = 0, vel = 0, lastX = 0, lastT = 0, raf;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; startX = e.clientX; startScroll = track.scrollLeft;
      lastX = e.clientX; lastT = performance.now(); vel = 0;
      cancelAnimationFrame(raf);
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
      var t = performance.now();
      if (t - lastT > 0) { vel = (lastX - e.clientX) / (t - lastT) * 16; lastX = e.clientX; lastT = t; }
    });
    function release() {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      (function glide() {
        if (Math.abs(vel) < 0.3) return;
        track.scrollLeft += vel;
        vel *= 0.94;
        raf = requestAnimationFrame(glide);
      })();
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    // a drag must not also trigger the rail's click-to-advance
    track.addEventListener('click', function (e) {
      if (Math.abs(track.scrollLeft - startScroll) > 6) { e.stopPropagation(); e.preventDefault(); }
    }, true);
    // gentle auto-drift (slow, per client feedback); pauses on hover/drag
    var hovering = false;
    track.addEventListener('mouseenter', function () { hovering = true; });
    track.addEventListener('mouseleave', function () { hovering = false; });
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      (function drift() {
        if (!down && !hovering) track.scrollLeft += 0.4;
        requestAnimationFrame(drift);
      })();
    }
  }
  function initAll() { document.querySelectorAll('[data-ar-slider]').forEach(initRepostSlider); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-absub-fan"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-absub-fan]').forEach(fan => {
  new IntersectionObserver(entries => entries.forEach(entry =>
    fan.classList.toggle('spread', entry.isIntersecting)
  ), { threshold: .4 }).observe(fan);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-why-app"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-whyapp]').forEach(function (section) {
  new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) section.classList.add('in-view');
    });
  }, { threshold: .25 }).observe(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byt-range"] && !Shopify.designMode) return;
  try {
    
/* One card open at a time: opening a card closes every sibling first. */
document.querySelectorAll('[data-byt-card]').forEach(card => card.addEventListener('click', e => {
  if (e.target.closest('a,button')) return;
  const open = !card.classList.contains('is-open');
  const scope = card.parentElement || document;
  scope.querySelectorAll('[data-byt-card].is-open').forEach(c => c.classList.remove('is-open'));
  card.classList.toggle('is-open', open);
}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-apply"] && !Shopify.designMode) return;
  try {
    

/*
  Open application form when any link points to #apply-form
*/

document.querySelectorAll('a[href="#apply-form"]').forEach(a => {

  a.addEventListener('click', e => {

    const form = document.querySelector('[data-apply-form]');

    if (!form) return;

    e.preventDefault();

    form.hidden = false;

    const role = form.querySelector(
      'input[name="contact[Role]"]'
    );

    if (role && !role.value) {

      role.value = (a.textContent || '')
        .replace(/[↗︎\s]+$/, '')
        .trim();

    }

    document
      .querySelector('[data-apply-toggle]')
      ?.setAttribute(
        'aria-expanded',
        'true'
      );

    form.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

  });

});


/*
  Apply Now button
*/

document.querySelectorAll('[data-apply-toggle]').forEach(btn => {

  btn.addEventListener('click', () => {

    const form = document.querySelector('[data-apply-form]');

    if (!form) return;

    const open = form.hidden;

    form.hidden = !open;

    btn.setAttribute(
      'aria-expanded',
      String(open)
    );

    if (open) {

      form.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });

    }

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
document.querySelectorAll('.qty-stepper').forEach(stepper => {
  const input = stepper.querySelector('input');
  const form = stepper.closest('form');
  let t = null;
  const submitSoon = () => { clearTimeout(t); t = setTimeout(() => form && form.requestSubmit(), 600); };
  stepper.querySelector('[data-qty-minus]').addEventListener('click', () => { input.value = Math.max(0, (+input.value || 0) - 1); submitSoon(); });
  stepper.querySelector('[data-qty-plus]').addEventListener('click', () => { input.value = (+input.value || 0) + 1; submitSoon(); });
  input.addEventListener('change', submitSoon);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collab-partnerships"] && !Shopify.designMode) return;
  try {
    
/* Open on hover, one card at a time. Driven from JS rather than a CSS :hover
   rule so it does not depend on the browser reporting a fine pointer; click is
   kept for touch, where mouseenter never fires. */
(function () {
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-cpar-card]'));
  function closeAll(except) {
    cards.forEach(function (c) { if (c !== except) c.classList.remove('is-open'); });
  }
  cards.forEach(function (card) {
    card.addEventListener('mouseenter', function () { closeAll(card); card.classList.add('is-open'); });
    card.addEventListener('mouseleave', function () { card.classList.remove('is-open'); });
    card.addEventListener('focusin', function () { closeAll(card); card.classList.add('is-open'); });
    card.addEventListener('click', function (e) {
      if (e.target.closest('a, button')) return;
      var open = !card.classList.contains('is-open');
      closeAll(null);
      card.classList.toggle('is-open', open);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["decks-locator"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('[data-decks]').forEach(section => {

  const tabs =
    [...section.querySelectorAll('.dl-tab')];

  const cardContainer =
    section.querySelector('[data-deck-cards]');

  const cards =
    [...section.querySelectorAll('[data-region-card]')];

  const prev =
    section.querySelector('[data-page-prev]');

  const next =
    section.querySelector('[data-page-next]');

  const pager =
    section.querySelector('[data-deck-pager]');

  const empty =
    section.querySelector('[data-empty-state]');

  const mapBox =
    section.querySelector('[data-deck-map]');

  const PAGE_SIZE =
    Number(section.dataset.pageSize || 8);


  let currentPage = 1;

  let activeRegion = 'mumbai';

  let mappyHost = null;



  /* ---------------------------
     TIMES
  --------------------------- */

  function formatTime(value) {

    if (!value) {
      return '';
    }

    let v =
      String(value)
        .trim()
        .replace(/\s+/g, ' ');


    if (/am|pm/i.test(v)) {

      return v
        .replace(/\s*(am|pm)/i, ' $1')
        .toLowerCase();

    }


    const match =
      v.match(
        /^(\d{1,2}):(\d{2})(?::\d{2})?$/
      );


    if (!match) {
      return v;
    }


    let hour =
      Number(match[1]);

    const minute =
      match[2];

    const suffix =
      hour >= 12
        ? 'pm'
        : 'am';


    hour =
      hour % 12;


    if (hour === 0) {
      hour = 12;
    }


    return `${hour}:${minute} ${suffix}`;

  }



  function formatHours(card) {

    const mo =
      formatTime(card.dataset.monOpen);

    const mc =
      formatTime(card.dataset.monClose);

    const so =
      formatTime(card.dataset.satOpen);

    const sc =
      formatTime(card.dataset.satClose);

    const uo =
      formatTime(card.dataset.sunOpen);

    const uc =
      formatTime(card.dataset.sunClose);


    const weekday =
      mo && mc
        ? `${mo} - ${mc}`
        : '';

    const saturday =
      so && sc
        ? `${so} - ${sc}`
        : '';

    const sunday =
      uo && uc
        ? `${uo} - ${uc}`
        : '';


    const lines = [];


    if (
      weekday &&
      weekday === saturday &&
      weekday === sunday
    ) {

      lines.push(
        `Mon-Sun ${weekday}`
      );

    }

    else if (
      saturday &&
      saturday === sunday
    ) {

      if (weekday) {

        lines.push(
          `Mon-Fri ${weekday}`
        );

      }


      lines.push(
        `Sat-Sun ${saturday}`
      );

    }

    else {

      if (weekday) {

        lines.push(
          `Mon-Fri ${weekday}`
        );

      }


      if (saturday) {

        lines.push(
          `Sat ${saturday}`
        );

      }


      if (sunday) {

        lines.push(
          `Sun ${sunday}`
        );

      }

    }


    const output =
      card.querySelector(
        '[data-hours-output]'
      );


    if (output) {

      output.innerHTML =
        lines.join('<br>');

    }

  }


  cards.forEach(formatHours);



  /* ---------------------------
     SORT A-Z
  --------------------------- */

  [...cards]
    .sort((a, b) => {

      const nameA =
        a.dataset.deckName || '';

      const nameB =
        b.dataset.deckName || '';


      return nameA.localeCompare(
        nameB,
        'en',
        {
          sensitivity: 'base',
          numeric: true
        }
      );

    })
    .forEach(card => {

      cardContainer.insertBefore(
        card,
        empty
      );

    });



  /* ---------------------------
     MAPPY POSITION
  --------------------------- */

  function positionMappy() {

    if (
      !mappyHost ||
      !mapBox
    ) {

      return;

    }


    const rect =
      mapBox.getBoundingClientRect();


    const visible =
      rect.bottom > 0 &&
      rect.top < window.innerHeight &&
      rect.width > 0 &&
      rect.height > 0;


    if (!visible) {

      mappyHost.style.visibility =
        'hidden';

      mappyHost.style.pointerEvents =
        'none';

      return;

    }


    mappyHost.style.visibility =
      'visible';

    mappyHost.style.pointerEvents =
      'auto';

    mappyHost.style.position =
      'fixed';

    mappyHost.style.left =
      `${rect.left}px`;

    mappyHost.style.top =
      `${rect.top}px`;

    mappyHost.style.width =
      `${rect.width}px`;

    mappyHost.style.height =
      `${rect.height}px`;

    mappyHost.style.margin =
      '0';

    mappyHost.style.padding =
      '0';

    mappyHost.style.zIndex =
      '15';

    mappyHost.style.overflow =
      'hidden';

    mappyHost.style.borderRadius =
      '24px';


    mapBox.classList.add(
      'has-mappy'
    );

  }



  function findMappy() {

    const block =
      document.querySelector(
        '.bss-map-block'
      );


    if (!block) {
      return false;
    }


    const host =
      block.closest(
        '.shopify-section'
      );


    if (!host) {
      return false;
    }


    mappyHost =
      host;


    mappyHost.classList.add(
      'ab-mappy-overlay'
    );


    positionMappy();


    return true;

  }



  window.addEventListener(
    'resize',
    positionMappy
  );


  window.addEventListener(
    'scroll',
    positionMappy,
    {
      passive: true
    }
  );



  /* ---------------------------
     CLOSE MAPPY POPUP
  --------------------------- */

  function closeMappyPopup() {

    const buttons = [

      ...document.querySelectorAll(
        '.gm-ui-hover-effect, button[aria-label="Close"], button[title="Close"]'
      )

    ];


    buttons.forEach(button => {

      try {

        button.click();

      }

      catch (error) {}

    });

  }



  /* ---------------------------
     FIND STORE IN MAPPY
  --------------------------- */

  function findMappyStore(card) {

    const lat =
      Number(card.dataset.lat);

    const lng =
      Number(card.dataset.lng);


    if (
      !Number.isFinite(lat) ||
      !Number.isFinite(lng)
    ) {

      return null;

    }


    const stores = [

      ...document.querySelectorAll(
        '#bss-search-result .bss-store-result'
      )

    ];


    return stores.find(el => {

      const onclick =
        el.getAttribute('onclick') || '';


      const match =
        onclick.match(
          /handleOnClickStoreName\(([-\d.]+),\s*([-\d.]+)/
        );


      if (!match) {
        return false;
      }


      return (

        Math.abs(
          Number(match[1]) - lat
        ) < 0.0002

        &&

        Math.abs(
          Number(match[2]) - lng
        ) < 0.0002

      );

    }) || null;

  }



  /* ---------------------------
     FOCUS STORE
  --------------------------- */

  function focusMappy(card) {

    const item =
      findMappyStore(card);


    if (!item) {
      return false;
    }


    try {

      item.click();

      return true;

    }

    catch (error) {

      return false;

    }

  }



  /* ---------------------------
     ZOOM OUT AFTER CITY CHANGE
  --------------------------- */

  function zoomMapOut() {

    const zoomOut =
      document.querySelector(
        'button[aria-label="Zoom out"], button[title="Zoom out"]'
      );


    if (!zoomOut) {
      return;
    }


    try {

      zoomOut.click();


      setTimeout(
        () => {

          zoomOut.click();

        },
        100
      );

    }

    catch (error) {}

  }



  /* ---------------------------
     MOVE MAP TO CITY
  --------------------------- */

  function moveMapToCity(region) {

    const regionCards =
      cards.filter(
        card =>
          card.dataset.regionCard
          === region
      );


    if (!regionCards.length) {
      return;
    }


    const firstCard =
      regionCards[0];


    setTimeout(
      () => {

        focusMappy(firstCard);

      },
      120
    );


    setTimeout(
      () => {

        closeMappyPopup();

      },
      300
    );


    setTimeout(
      () => {

        zoomMapOut();

      },
      450
    );


    setTimeout(
      () => {

        closeMappyPopup();

        positionMappy();

      },
      800
    );

  }



  /* ---------------------------
     CARD CLICK
  --------------------------- */

  cards.forEach(card => {

    card.addEventListener(
      'click',
      event => {

        if (
          event.target.closest(
            'a,button'
          )
        ) {

          return;

        }


        focusMappy(card);

      }
    );

  });



  /* ==========================================
     TA MAPPY GET DIRECTIONS -> GMB

     Only affects the button inside
     the TA MAPPY map popup.

     Right-side cards stay unchanged.
  ========================================== */

  function normalizeOutletName(value) {

    return String(value || '')
      .toLowerCase()
      .replace(/ab\.?coffee/g, '')
      .replace(/[^a-z0-9]/g, '');

  }


  document.addEventListener(
    'click',
    event => {

      const button =
        event.target.closest(
          'a, button'
        );


      if (!button) {
        return;
      }


      const buttonText =
        String(
          button.textContent || ''
        )
          .trim()
          .toLowerCase();


      if (
        buttonText.indexOf(
          'get directions'
        ) === -1
      ) {

        return;

      }


      /*
        Do not touch the right-side
        card Get Directions button.
      */

      if (
        !button.closest(
          '.ab-mappy-overlay'
        )
      ) {

        return;

      }


      /*
        Find the TA MAPPY popup
        containing the clicked button.
      */

      const popup =
        button.closest(
          '.gm-style-iw-c, .gm-style-iw, [role="dialog"]'
        );


      if (!popup) {
        return;
      }


      const popupText =
        normalizeOutletName(
          popup.textContent
        );


      /*
        Match popup outlet name
        with Shopify Deck card.
      */

      const matchingCard =
        cards.find(card => {

          const cardName =
            normalizeOutletName(
              card.dataset.deckName
            );


          return (
            cardName &&
            popupText.indexOf(
              cardName
            ) !== -1
          );

        });


      if (!matchingCard) {
        return;
      }


      /*
        Get the GMB URL that is already
        on the matching card.
      */

      const cardDirectionsButton =
        matchingCard.querySelector(
          '.dl-go'
        );


      if (!cardDirectionsButton) {
        return;
      }


      const gmbUrl =
        cardDirectionsButton.href;


      if (!gmbUrl) {
        return;
      }


      /*
        Stop TA MAPPY's own
        Get Directions URL.
      */

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      /*
        Open abcoffee GMB link.
      */

      window.open(
        gmbUrl,
        '_blank',
        'noopener'
      );

    },
    true
  );



  /* ---------------------------
     PAGINATION
  --------------------------- */

  function render() {

    const regionCards =
      cards.filter(
        card =>
          card.dataset.regionCard
          === activeRegion
      );


    const pages =
      Math.max(
        1,
        Math.ceil(
          regionCards.length /
          PAGE_SIZE
        )
      );


    currentPage =
      Math.min(
        Math.max(
          currentPage,
          1
        ),
        pages
      );


    cards.forEach(card => {

      card.classList.add(
        'is-hidden'
      );

    });


    regionCards.forEach(
      (card, index) => {

        const page =
          Math.floor(
            index / PAGE_SIZE
          ) + 1;


        if (
          page === currentPage
        ) {

          card.classList.remove(
            'is-hidden'
          );

        }

      }
    );


    if (empty) {

      empty.classList.toggle(
        'is-hidden',
        regionCards.length > 0
      );

    }


    if (pager) {

      pager.classList.toggle(
        'is-hidden',
        pages <= 1
      );

    }


    if (prev) {

      prev.disabled =
        currentPage <= 1;

    }


    if (next) {

      next.disabled =
        currentPage >= pages;

    }


    requestAnimationFrame(
      positionMappy
    );

  }



  prev?.addEventListener(
    'click',
    () => {

      if (currentPage <= 1) {
        return;
      }


      currentPage--;


      render();


      section
        .querySelector('.dl-regions')
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

    }
  );



  next?.addEventListener(
    'click',
    () => {

      const regionCards =
        cards.filter(
          card =>
            card.dataset.regionCard
            === activeRegion
        );


      const pages =
        Math.max(
          1,
          Math.ceil(
            regionCards.length /
            PAGE_SIZE
          )
        );


      if (
        currentPage >= pages
      ) {

        return;

      }


      currentPage++;


      render();


      section
        .querySelector('.dl-regions')
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

    }
  );



  /* ---------------------------
     CITY TABS
  --------------------------- */

  tabs.forEach(tab => {

    tab.addEventListener(
      'click',
      () => {

        tabs.forEach(item => {

          item.classList.toggle(
            'is-active',
            item === tab
          );

        });


        activeRegion =
          tab.dataset.region;


        currentPage = 1;


        render();


        moveMapToCity(
          activeRegion
        );

      }
    );

  });



  /* ---------------------------
     INITIALISE MAPPY
  --------------------------- */

  if (!findMappy()) {

    let attempts = 0;


    const finder =
      setInterval(
        () => {

          attempts++;


          if (
            findMappy() ||
            attempts > 100
          ) {

            clearInterval(
              finder
            );

          }

        },
        200
      );

  }



  render();


  setTimeout(
    () => {

      findMappy();

      moveMapToCity(
        activeRegion
      );

      positionMappy();

    },
    1000
  );


  setTimeout(
    () => {

      closeMappyPopup();

      positionMappy();

    },
    2200
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifting-hampers"] && !Shopify.designMode) return;
  try {
    

document
  .querySelectorAll('.hamper-card')
  .forEach(function(card) {

    card.addEventListener('click', function() {

      if (
        window
          .matchMedia('(hover:hover)')
          .matches
      ) {
        return;
      }

      card.classList.toggle('is-open');

    });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-category-tiles"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-menu-tile]').forEach(function (tile) {
  tile.addEventListener('click', function () {
    var grid = document.querySelector('#menu-list');
    if (!grid) return;
    var btn = grid.querySelector('[data-tab="' + tile.dataset.menuTile + '"]');
    if (btn) btn.click();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-catalog"] && !Shopify.designMode) return;
  try {
    
  function initialiseShopCatalogues() {
    document.querySelectorAll('[data-shop-catalogue]').forEach(section => {
      if (section.dataset.filtersReady === 'true') return;

      section.dataset.filtersReady = 'true';

      const tabs = Array.from(
        section.querySelectorAll('[data-shop-filter]')
      );

      const products = Array.from(
        section.querySelectorAll('.product[data-category]')
      );

      const emptyMessage = section.querySelector('[data-shop-empty]');

      function applyFilter(filter) {
        let visibleCount = 0;

        tabs.forEach(tab => {
          const active = tab.dataset.shopFilter === filter;

          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });

        products.forEach(product => {
          const visible =
            filter === 'all' ||
            product.dataset.category === filter;

          product.hidden = !visible;

          if (visible) visibleCount += 1;
        });

        if (emptyMessage) {
          emptyMessage.hidden = visibleCount > 0;
        }
      }

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          applyFilter(tab.dataset.shopFilter);
        });
      });

      const initialTab =
        tabs.find(tab => tab.classList.contains('is-active')) ||
        tabs[0];

      if (initialTab) {
        applyFilter(initialTab.dataset.shopFilter);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseShopCatalogues
    );
  } else {
    initialiseShopCatalogues();
  }

  document.addEventListener(
    'shopify:section:load',
    initialiseShopCatalogues
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-cards"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-subcards]').forEach(function (root) {
  var track = root.querySelector('[data-sc-track]');
  var cards = [].slice.call(root.querySelectorAll('[data-sc-card]'));
  var prev = root.querySelector('[data-sc-prev]');
  var next = root.querySelector('[data-sc-next]');
  var dotsWrap = root.querySelector('[data-sc-dots]');
  if (!track || !cards.length) return;

  var dots = dotsWrap ? cards.map(function (c, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.addEventListener('click', function () { scrollToCard(i); });
    dotsWrap.appendChild(b);
    return b;
  }) : [];

  function centreOf(el) {
    var r = el.getBoundingClientRect();
    return r.left + r.width / 2;
  }
  function activeIndex() {
    var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
    var best = 0, bestD = Infinity;
    cards.forEach(function (c, i) {
      var d = Math.abs(centreOf(c) - mid);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }
  function scrollToCard(i) {
    i = Math.max(0, Math.min(cards.length - 1, i));
    var c = cards[i];
    track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.clientWidth) / 2, behavior: 'smooth' });
  }
  function sync() {
    var a = activeIndex();
    cards.forEach(function (c, i) { c.classList.toggle('is-active', i === a); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === a); });
    if (prev) prev.disabled = a <= 0;
    if (next) next.disabled = a >= cards.length - 1;
  }
  prev && prev.addEventListener('click', function () { scrollToCard(activeIndex() - 1); });
  next && next.addEventListener('click', function () { scrollToCard(activeIndex() + 1); });
  var raf;
  track.addEventListener('scroll', function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(sync);
  }, { passive: true });
  window.addEventListener('resize', sync);
  // start on the feature card if there is one, else the middle
  var startFeature = cards.findIndex(function (c) { return c.classList.contains('is-feature'); });
  var start = startFeature >= 0 ? startFeature : Math.floor(cards.length / 2);
  function init() { scrollToCard(start); sync(); }
  // run immediately and again after layout settles (rAF can be throttled in bg tabs)
  init();
  requestAnimationFrame(init);
  setTimeout(init, 120);
  window.addEventListener('load', init);
});

  } catch(e) { console.error(e); }
})();
})();
